import axiosInstance from '@/setup/axios/axiosInstance'
import {JobTitleModel, JobTitleResponse} from '../models/JobTitleModel'

// Get all job titles
export function getJobTitles() {
  return axiosInstance.get<JobTitleResponse>('/job-titles/')
}

// Get single job title by ID
export function getJobTitle(id: number) {
  return axiosInstance.get<JobTitleModel>(`/job-titles/${id}/`)
}

// Create new job title
export function createJobTitle(jobTitleData: Partial<JobTitleModel>) {
  return axiosInstance.post<JobTitleModel>('/job-titles/', jobTitleData)
}

// Update job title
export function updateJobTitle(id: number, jobTitleData: Partial<JobTitleModel>) {
  return axiosInstance.put<JobTitleModel>(`/job-titles/${id}/`, jobTitleData)
}

// Delete job title
export function deleteJobTitle(id: number) {
  return axiosInstance.delete(`/job-titles/${id}/`)
} 